import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushTemoignages } from '@components/push-temoignages/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { ResponsiveService } from '@shared/services/responsive';

@Component({
  selector: 'app-push-temoignages',
  templateUrl: './push-temoignages.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, ImageComponent, SvgComponent, RouterLink, ButtonComponent],
})
export class PushTemoignagesComponent extends AbstractDynamicComponent<PushTemoignages> {
  private readonly responsiveService = inject(ResponsiveService);
  protected readonly isDesktop = computed(() => this.responsiveService.breakpoints() === 'desktop');
  private readonly elasticSearchService = inject(ElasticSearchService);
  private readonly router = inject(Router);
  protected readonly testimonies = toSignal(this.elasticSearchService.getLatestTestimonies(2, this.router.url), {
    initialValue: [],
  });
}
